﻿import { Component, Input, OnInit, Output,EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { LocalService, SellerService } from 'src/app/core';
import { SellerRewardsDialogComponent } from 'src/app/shared';

 
@Component({
  selector: 'sales-challenge-card',
  templateUrl: './sales-challenge-card.component.html',
  styleUrls: ['./sales-challenge-card.component.scss'],
})


export class SalesChallengeCardComponent implements OnInit  {
  bonusIncentivesList:any;
  salesBonusPage = 1;
  userProfile;
  salesBonusSize = 4;
  @Input() bonusData: any ;
  @Output() activityChallenge = new EventEmitter();
 @Input() roleData;any;
  partnerName:string;
  constructor(private router: Router ,
    private sellerService: SellerService,
    private dialog: MatDialog){}
    pamData:any='';
     pviEligible:boolean=false;
        isTermsOpen = false;
   termsChallenge: any = null;
  ngOnInit(): void {
    console.log('[ChallengeCard] ngOnInit | bonusData:', this.bonusData, '| roleData:', this.roleData);
    this.userProfile = LocalService.get('userProfile');
        if( ((this.userProfile.pvieligible===false) || (this.userProfile.companyEligibleChallengesDTO && (this.userProfile.companyEligibleChallengesDTO.pvieligible===false)))){

      this.pviEligible=true;
    }
    if((this.userProfile.hasOwnProperty('userType')&&this.userProfile.userType=='PAM')){
      this.pamData= LocalService.get('pamData');
      if(this.pamData && this.pamData.pamBeGeoIdsDTO && this.pamData.pamBeGeoIdsDTO.beGeoIds && this.pamData.pamBeGeoIdsDTO.beGeoIds.content && this.pamData.pamBeGeoIdsDTO.beGeoIds.content.length > 0 && this.pamData.pamBeGeoIdsDTO.beGeoIds.content[0].companyEligibleChallengesDTO && this.pamData.pamBeGeoIdsDTO.beGeoIds.content[0].companyEligibleChallengesDTO.pvieligible===false){
        this.pviEligible=true;
      }
    }
    if(this.router.url.includes('home/manager')){
      this.partnerName='leader';
    }else{
      this.partnerName='seller';
    }
    console.log('[ChallengeCard] ngOnInit complete | pviEligible:', this.pviEligible, '| partnerName:', this.partnerName);

  }


  ngOnChanges(){
    console.log('[ChallengeCard] ngOnChanges | bonusData:', this.bonusData);
    if(this.bonusData){
      console.log('[ChallengeCard] bonusData.content:', this.bonusData.content, '| length:', this.bonusData.content ? this.bonusData.content.length : 'no content key');
      if(this.bonusData.content.length>0){
        this.bonusIncentivesList=this.bonusData;
        console.log('[ChallengeCard] bonusIncentivesList SET with', this.bonusIncentivesList.content.length, 'items');
      } else {
        console.warn('[ChallengeCard] bonusData.content is EMPTY — bonusIncentivesList not set');
        // this.bonusData= {"content":[
        // {"id":111,"scNumber":"SC-BFQN-123_01","name":"base FY23 Q1 New","shortName":"","description":"description","award":"rewards based on payout page","type":null,"salesChallengeType":"SPECIAL","regions":["USA"],"quarter":"Q1","fiscalYear":"2023","identifier":"base-FY23-Q1-New","version":"v2","isthisNewChallenge":false,"bookingDateRangeStart":"2022-07-31","bookingDateRangeEnd":"2022-10-29","capUtilizationPercentage":0.0,"attachments":[{"createdBy":null,"modifiedBy":null,"id":77,"identifier":null,"name":"skus_test_(1).xlsx","description":null,"url":"http://52.90.95.177:9092/shared/files/skus_test_(1).xlsx","fileSize":"8 KB","extension":"xlsx","region":"USA","category":"TERMS_AND_CONDITIONS"}],"challengePeriod":"FY23 Q1","visibleToLeader":true,"visibleToSeller":true,"anyTrainingChallengesTagged":true,"trainingChallengeCompleted":false},
        // {"id":41,"scNumber":"SC-TD1-123_01","name":"test dev 1208","shortName":"","description":"description","award":"rewards","type":null,"salesChallengeType":"SPECIAL","regions":["USA"],"quarter":"Q1","fiscalYear":"2023","identifier":"test-dev-1208","version":"v2","isthisNewChallenge":false,"bookingDateRangeStart":"2022-07-31","bookingDateRangeEnd":"2022-10-29","capUtilizationPercentage":0.0,"attachments":[{"createdBy":null,"modifiedBy":null,"id":61,"identifier":null,"name":"Sample_TandC_3.pdf","description":null,"url":"http://52.90.95.177:9092/shared/files/Sample_TandC_3.pdf","fileSize":"317 KB","extension":"pdf","region":"USA","category":"TERMS_AND_CONDITIONS"},{"createdBy":null,"modifiedBy":null,"id":64,"identifier":null,"name":"Sample_SKUs_usa.pdf","description":null,"url":"http://52.90.95.177:9092/shared/files/Sample_SKUs_usa.pdf","fileSize":"171 KB","extension":"pdf","region":"USA","category":"ELIGIBLE_PRODUCT_LIST"}],"challengePeriod":"FY23 Q1","visibleToLeader":true,"visibleToSeller":true,"anyTrainingChallengesTagged":false,"trainingChallengeCompleted":true},
        // {"id":31,"scNumber":"SC-T-123_01","name":"test-dev-1008","shortName":"","description":"description","award":"Earn Seller Rewards points for every order sold to Cisco-defined Small and Midsize customers that include eligible Cisco products.","type":null,"salesChallengeType":"SPECIAL","regions":["USA"],"quarter":"Q1","fiscalYear":"2023","identifier":"test","version":"v2","isthisNewChallenge":false,"bookingDateRangeStart":"2022-07-31","bookingDateRangeEnd":"2022-10-29","capUtilizationPercentage":0.0,"attachments":[{"createdBy":null,"modifiedBy":null,"id":47,"identifier":null,"name":"Sample_TandC_1.pdf.pdf","description":null,"url":"http://52.206.239.244:9092/shared/files/Sample_TandC_1.pdf.pdf","fileSize":"371 KB","extension":"pdf","region":"USA","category":"TERMS_AND_CONDITIONS"},{"createdBy":null,"modifiedBy":null,"id":50,"identifier":null,"name":"Sample_SKUs_usa.pdf.pdf","description":null,"url":"http://52.206.239.244:9092/shared/files/Sample_SKUs_usa.pdf.pdf","fileSize":"171 KB","extension":"pdf","region":"USA","category":"ELIGIBLE_PRODUCT_LIST"}],"challengePeriod":"FY23 Q1","visibleToLeader":false,"visibleToSeller":true,"anyTrainingChallengesTagged":true,"trainingChallengeCompleted":true}],
        // "pageable":{"sort":{"sorted":false,"unsorted":true},"pageSize":3,"pageNumber":0,"offset":0,"paged":true,"unpaged":false},"totalElements":12,"totalPages":4,"last":false,"numberOfElements":3,"sort":{"sorted":false,"unsorted":true},"first":true,"size":3,"number":0}
      }
    } else {
      console.warn('[ChallengeCard] ngOnChanges called but bonusData is null/undefined');
    }
  }

  redirectToManageClaim(){
    if(this.router.url=='/home/seller/challenges'){
      this.router.navigateByUrl('home/seller/manage-claims');
    }else{
      this.router.navigateByUrl('home/manager/admin-manage-claims');
    }
  }
  challengeId;
  // showTrainingFlag:boolean=false;
  onClickGototraining(list){
  
  this.activityChallenge.emit({flag:true,showSpecialTab:true})

  }
switchToSaleschallenge(list){
  list.showTrainingFlag=false;
}
showTraining(list){
  // this.challengeId=list.id;
  // list.showTrainingFlag=true;
  this.activityChallenge.emit({flag:true,showSpecialTab:true});
}
  // on click on prev & next call bonus incentives api
 
  showMoreBonusSalesChallenges(pageNumber) {
    this.salesBonusPage = pageNumber;
    let beGeoId = this.userProfile.company.beGeoId;
    if (this.pamData !== '') {
      const beGeoIds = this.pamData.pamBeGeoIdsDTO ? this.pamData.pamBeGeoIdsDTO.beGeoIds : this.pamData.beGeoIds;
      beGeoId = (beGeoIds.content && beGeoIds.content.length > 0) ? beGeoIds.content[0].beGeoId : (beGeoIds.length > 0 ? beGeoIds[0].beGeoId : this.userProfile.company.beGeoId);
    }
    const params = {
      region: this.userProfile.company.region,
      beGeoId: beGeoId,
      page: this.salesBonusPage - 1,
      size: this.salesBonusSize,
      console: localStorage.getItem('selectedRole') == 'manager' ? 'LEADER' : 'SELLER'
    };
    console.log('parm',params)
    this.sellerService.getBonusIncentives(params).subscribe((data) => {
      if (data && data.content.length) {
        //this.showTrainingFlag=false;
        this.bonusIncentivesList.content = data.content;
      }
    }, err => {
      
    });
  }
    // on click on download open popup
    downloadList(data){
      if(data!=null ){
        const dialogRef = this.dialog.open(SellerRewardsDialogComponent, {
        
          data: { 'name': 'downloadAttachments','filaeData':data},
          width:'50%',
        panelClass:'download-doc-popup'
        });
        dialogRef.afterClosed().subscribe(result => {
        });
      }
    }

    selectedChallenge: any = null;
  isDrawerOpen = false;

  openDrawer(challenge: any) {
    this.selectedChallenge = challenge;
    this.isDrawerOpen = true;
  }

  closeDrawer() {
    this.isDrawerOpen = false;
  }

  splitData(value) {
      const parseValue = parseFloat(value);
      const newData = parseValue.toLocaleString();
      return newData.toString();
    }
      openTermsModal(challenge: any) {
    this.termsChallenge = challenge;
    this.isTermsOpen = true;
  }
  
  closeTermsModal() {
    this.isTermsOpen = false;
    this.termsChallenge = null;
  }
  hasEarnUpTo(text: string): boolean {
  return text && text.includes('Earn up to') ? true : false;
}

getRestText(text: string): string {
  return text ? text.replace('Earn up to', '').trim() : '';
}
getParts(text: string): string[] {
  const rest = text ? text.replace('Earn up to', '').trim() : '';
  return rest.split(' ').filter(function(p) { return p !== ''; });
}

isNumber(part: string): boolean {
  return !isNaN(Number(part.replace(/[,$]/g, '')));
}
}

